import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import { UserContext } from '../../../../AppContext';
import hasWriteAccess from '../../../../util/hasWriteAccess';

export default function ReportsToolbar({
  local,
  archive,
  city,
  onAddClick,
  onArchiveClick,
}) {
  const user = useContext(UserContext);
  return (
    <GridToolbarContainer>
      <Button variant="text" color={archive ? 'primary' : 'secondary'} size="small" onClick={() => onArchiveClick(!archive)}>
        {local.archive}
      </Button>
      { city && hasWriteAccess(user, city.district, city.id) && (
        <Button variant="text" color="primary" size="small" onClick={onAddClick}>
          {local.add}
        </Button>
      )}
      { (user.admin || user.control) && (
        <Button variant="text" color="secondary" size="small" onClick={() => setTimeout(() => window.alert('ERROR 412 - Berichte exportieren: Laufzeitfehler'), 3000)}>
          {local.exportReport}
        </Button>
      )}
      <Box sx={{ flexGrow: 1 }} />
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarExport csvOptions={{ delimiter: ';', utf8WithBom: true }} />
    </GridToolbarContainer>
  );
}

ReportsToolbar.propTypes = {
  archive: PropTypes.bool.isRequired,
  city: PropTypes.shape({
    id: PropTypes.number,
    district: PropTypes.number,
  }),
  local: PropTypes.shape({
    add: PropTypes.string,
    archive: PropTypes.string,
    exportReport: PropTypes.string,
  }).isRequired,
  onAddClick: PropTypes.func.isRequired,
  onArchiveClick: PropTypes.func.isRequired,
};

ReportsToolbar.defaultProps = {
  city: undefined,
};
